import { cn } from "@/lib/utils";
import { TONE_BADGE, TONE_DOT, type Tone } from "../lib/status";
import type { Preview, PreviewStatus, PreviewSummary } from "../types";

const PREVIEW_TONE: Record<PreviewStatus, Tone> = {
  requested: "neutral",
  provisioning: "sky",
  updating: "sky",
  ready: "emerald",
  stopped: "neutral",
  expired: "neutral",
  failed: "red",
};

const PREVIEW_LABEL: Record<PreviewStatus, string> = {
  requested: "Requested",
  provisioning: "Building",
  updating: "Updating",
  ready: "Ready",
  stopped: "Stopped",
  expired: "Expired",
  failed: "Failed",
};

const PULSING: ReadonlySet<PreviewStatus> = new Set(["provisioning", "updating"]);

export function PreviewStatusBadge({
  preview,
  className,
}: {
  preview: Pick<Preview | PreviewSummary, "status" | "phase">;
  className?: string;
}) {
  const tone = PREVIEW_TONE[preview.status];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium",
        TONE_BADGE[tone],
        className,
      )}
    >
      <span
        className={cn(
          "size-1.5 rounded-full",
          TONE_DOT[tone],
          PULSING.has(preview.status) && "animate-pulse",
        )}
      />
      {PREVIEW_LABEL[preview.status]}
      {PULSING.has(preview.status) && preview.phase ? ` · ${preview.phase}` : ""}
    </span>
  );
}
